import React, { useEffect, useState } from 'react';
// import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import Input from '../../shared/Input';
import Button from '../../shared/Button';
import '../../../css/assignRole/AssignRole.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Sidenav from '../../shared/Sidenav';
import RespModal from '../../shared/RespModal';
import DeleteModal from '../../shared/DeleteRoleModal';
import viewAccess from '../../../assets/images/viewOnlyAccess.svg';
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { Image } from 'react-bootstrap';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { baseURL } from '../../../Services/config/apiGateway';
import { ALLROLES_ENDPOINT, ALLUSERROLELIST_ENDPOINT, ASSIGNROLE_ENDPOINT, ALLUSERLIST_ENDPOINT } from '../../../Services/config/apiEndPoints';
import Loader from 'react-loader';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
function AssignRole() {
    const [dropdown, setdropdown] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [showEmailSearch, setShowEmailSearch] = useState(false);
    const selectPlaceHolder = '--Select Role--';
    const [input, setInput] = useState("");
    const [hasopen, setHasopen] = useState(false);
    const container = React.createRef();
    const [userEmail, setUserEmail] = useState('');
    const [roles, setRoles] = useState([]);
    const [isEditAssignRole, setIsEditAssignRole] = useState([]);
    const [assignroleEditDropdown, setAssignroleEditDropdown] = useState([]);
    const [roleSelected, setRoleSelected] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [roleSelectStatus, setRoleSelectStatus] = useState([]);
    const [userRoleList, setUserRoleList] = useState([]);
    const [editIndex, setEditIndex] = useState('');
    const [deleteIndex, setDeleteIndex] = useState('');
    const [hasOpenDelete, setHasOpenDelete] = useState(false);
    const [openAssignRole, setOpenAssignRole] = useState(false);
    const [pageDisable, setPageDisable] = useState(true);
    const [loaderTime, setLoaderTime] = useState(true);
    let [userSearch, setUserSearch] = useState([]);
    var selectedTiles = [];
    let viewOnly = false;
    let roleData = useSelector(state => state.adminRoleReducer.roleData)
    const roleDataLength = roleData.length;
    for (let z = 0; z < roleDataLength; z++) {
        var rd = roleData[z].permissions;
        selectedTiles.push(rd)
    }
    selectedTiles.map(x =>
        x.map(md => {
            if (md.functionId == 12) {
                if (md.method.includes("View & Edit")) {
                    viewOnly = true
                }
            }
        }))
    useEffect(() => {
        let unmounted = false;
        window.scrollTo(0, document.querySelector("#assignRoleDataContainer").scrollHeight);
        //   GET ALL USER ROLE LIST API
        ApiCall(
            'GET',
            baseURL + ALLUSERROLELIST_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            },
        ).then((apiData) => {
            if (!unmounted) {
                if (apiData.flag !== -1) {
                    if (apiData.flag === 500) {
                        toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                    }
                    else {
                        console.log('I am 200!');
                        console.log(apiData.filter(user => user.userType == "TPT Internal"));
                        setUserRoleList(apiData.filter(user => user.userType == "TPT Internal"));
                        setLoaderTime(false);
                        setPageDisable(false);
                    }
                } else {
                    // toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
            }
        });
        //   GET ALL ROLES API
        ApiCall(
            'GET',
            baseURL + ALLROLES_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            },
        ).then((apiData) => {
            if (!unmounted) {
                if (apiData.flag !== -1) {
                    if (apiData.flag === 500) {
                        toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                    }
                    else {
                        console.log('I am 200!');
                        console.log(apiData);
                        setRoles(apiData);
                    }
                } else {
                    // toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
            }
        });
        return () => { unmounted = true };
    }, [])
    const handleClickOutside = event => {
        if (container.current && !container.current.contains(event.target)) {
            setdropdown(false);
            setShowSearch(false);
            setShowEmailSearch(false);
            assignroleEditDropdown[editIndex] = false;
            setAssignroleEditDropdown(assignroleEditDropdown);
        }
    };
    document.addEventListener("mousedown", handleClickOutside);
    const validateFormFields = () => {
        let validEdit = [];
        let indexOfedits = [];
        isEditAssignRole.find((edit, index) => {
            console.log(edit)
            if (edit === true) {
                indexOfedits = indexOfedits.concat(index);
            }
        });
        for (let i = 0; i < indexOfedits.length; i++) {
            validEdit = validEdit.concat(userRoleList[indexOfedits[i]].profileRoles.length > 0);
            console.log("insideValidedit", validEdit);
        }
        return (input.length > 0 && userEmail.length > 0 && roleSelected === true) ||
            (!validEdit.includes(false) && isEditAssignRole.includes(true))
    };
    const onCloseConfirmedModal = () => {
        setHasopen(false);
        console.log("selected role", getSelectedRoles())
        window.location.reload()
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        ApiCall(
            'PUT',
            baseURL + ASSIGNROLE_ENDPOINT + `${isEditAssignRole[editIndex] ? userRoleList[editIndex].emailId : userEmail}/roles`,
            isEditAssignRole[editIndex] ? confirmUpdateRoleDetail() : getSelectedRoles(),
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            }
        ).then(apiData => {
            if (apiData.flag !== -1) {
                if (apiData.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    setHasopen(true);
                    setHasOpenDelete(false);
                }
            }
            else {
                //    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
            }
        })
    }
    const toggleDropdown = () => {
        setdropdown(!dropdown);
    }
    const getSelectedRoles = () => {
        let selectedTerminals = [];
        roleSelectStatus.map((val, key) => {
            if (val) {
                selectedTerminals.push({
                    name: roles[key].name,
                    type: roles[key].type,
                    roleId: roles[key].roleId,
                    permissions: roles[key].permissions
                });
            }
        })
        return selectedTerminals;
    }
    const updateAssignRole = (rowindex, dropdownIndex) => {
        //updating the permissions for a particular function of a roleType
        let roleId = roles[dropdownIndex].roleId;
        if (userRoleList[rowindex].profileRoles.filter(p => p.roleId == roleId).length > 0) {
            //remove this role
            console.log('present');
            let profileRoles = userRoleList[rowindex].profileRoles;
            profileRoles = profileRoles.filter(p => p.roleId != roleId);
            let userDetails = userRoleList;
            userDetails[rowindex].profileRoles = profileRoles;
            setUserRoleList(userDetails)
        }
        else {
            // add this role
            let profileRoles = userRoleList[rowindex].profileRoles;

            let r = roles[dropdownIndex];
            r = {
                permissions: r.permissions,
                // profileStatus: '', // not present in role data, but present in user role data
                roleId: r.roleId,
                roleName: r.name,
                roleType: r.type,
            }
            profileRoles.push(r);
            let userDetails = userRoleList;
            userDetails[rowindex].profileRoles = profileRoles;
            setUserRoleList(userDetails)
        }
        console.log("upated Dtat", userRoleList[rowindex].profileRoles)
        return userRoleList[rowindex].profileRoles
    }
    const confirmUpdateRoleDetail = (userIndex) => {
        let profileRoles = userRoleList[editIndex].profileRoles;
        let userRole = [];
        profileRoles.map((val, key) => {
            userRole.push({
                name: profileRoles[key].roleName,
                permissions: profileRoles[key].permissions,
                roleId: profileRoles[key].roleId,
                type: profileRoles[key].roleType
            });
        })
        return userRole;
    }
    const onCloseDeleteModal = () => {
        setHasOpenDelete(false);
    }
    const unassignRoleFromUser = () => {
        ApiCall(
            'PUT',
            baseURL + ASSIGNROLE_ENDPOINT + `${userRoleList[deleteIndex].emailId}/roles`,
            [],

            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            }
        ).then(apiData => {
            if (apiData.flag !== -1) {
                if (apiData.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    setHasopen(true);
                    setHasOpenDelete(false);
                }
            }
            else {
                //    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
            }
        })
    }
    const deleteAssignRole = (index) => {
        setDeleteIndex(index);
        setHasOpenDelete(true);
    }
    const handlechange = (e) => {
        setInput(e.target.value);
        var test1 = e.target.value.length
        if (test1 == 3) {
            //   GET ALL USER LIST API
            ApiCall(
                'GET',
                baseURL + ALLUSERLIST_ENDPOINT + `${e.target.value}`,
                {},
                {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-cc-trace-id': '1234',
                },
            ).then((apiData) => {
                if (apiData.flag !== -1) {
                    if (apiData.flag === 500) {
                        toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                    }
                    else {
                        console.log('I am 200!');
                        setUserSearch(apiData);
                        setShowSearch(true);
                        setIsEditMode(true);
                    }
                } else {
                    // toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
            });
        }
    };
    const handleEmailInput = (e) => {
        setUserEmail(e.target.value);
    };
    const searchEmail = () => {
        setShowEmailSearch(true);
    }
    const selectEmail = (e) => {
        const found = userSearch.find((name) => {
            if (name.userEmail === e.target.innerText) {
                return name
            }
        })
        setUserEmail(found.userEmail);
        setShowEmailSearch(false);
    }
    const selectName = (event) => {
        const found = userSearch.find((name) => {
            if (name.firstName + " " + name.lastName === event.target.innerText) {
                return name
            }
        })
        setInput(found.firstName + " " + found.lastName);
        setShowSearch(false);
    };
    if (input.length > 3) {
        userSearch = userSearch.filter((i) => {
            return ((i.firstName + " " + i.lastName).toLowerCase().match(input) || (i.firstName + " " + i.lastName).match(input));
        });
    }
    return (
        <div className="outerar1" id={pageDisable ? "disabletrue" : ""}><div className="outerar1" id="outerdiv">
            <MetaDecorator title={TitleDescription.assignRolePageTitle} description={TitleDescription.assignRolePageDescription} />
            <Loader
                loaded={!loaderTime}
                lines={10}
                length={10}
                width={10}
                radius={10}
                corners={1}
                rotate={0}
                direction={1}
                color="#000"
                speed={1}
                trail={60}
                shadow={false}
                hwaccel={false}
                className='spinner'
                zIndex={2e9}
                top="50%"
                left="50%"
                scale={1.0}
                loadedClassName="loadedContent"
            />
            <div class="container-fluid home">
                <Sidenav />
                <div class="assignRoleOuter" id="assignRolePart">
                    <h6 class="pt-2 pb-3" id="assignRoleText">Assign Role</h6>
                    <div className="viewOnlyDiv" style={{ display: !viewOnly ? null : "none" }}>
                        <img alt="View Only Access" src={viewAccess} />
                        <span className="viewOnly">View Only Access</span>
                    </div>
                    <div className="assignRoleContainer">
                        <table class="table bg-white " id="assignRoleTable">
                            <tbody>
                                <tr className="tablenav">
                                    <td className="navData" id="fullnametd">
                                        <small class="p-3 pt-3 " className="assignRoleHeading" id="fullnameText">Full Name</small>
                                    </td>
                                    <td className="navData" id="emailtd">
                                        <small class="pb-3 pt-3 " className="assignRoleHeading" id="emailText">Email Address</small>
                                    </td>
                                    <td className="navData">
                                        <small class="pb-3 pt-3 " className="assignRoleHeading" id="assignroleText">Assign Role</small>
                                    </td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                        <div id="assignRoleDataContainer">
                            <table class="" id="assignroletable">
                                <tbody>
                                    {/* user role list */}
                                    {(userRoleList.map((name, dataindex) =>
                                        (name.userType == "TPT Internal")
                                        &&
                                        <tr className="assignRoleData">
                                            <td id="assignroletd" className="assignRoleTableData">
                                                <label class="p-2" id="assignrolelable" >
                                                    <div class="assignroledisplayflex">
                                                        <div className="pass-wrapper" class="assignroleinputdiv">
                                                            <small
                                                                id="arrownameInput"
                                                                class="form-control form-control-sm outline4"> {name.firstName + " " + name.lastName}</small>
                                                        </div>
                                                    </div>
                                                </label>
                                            </td>
                                            <td id="assignroleTableData" className="assignRoleTableData">
                                                <label class="pt-2" id="userEmailText">
                                                    <div className="pass-wrapper" class="assignroleinputdiv">
                                                        <small id="arrowemailInput" class="form-control form-control-sm ">
                                                            {name.emailId}</small>
                                                    </div>
                                                </label>
                                            </td>
                                            <td id="roleAssignTd" className="assignRoleTableData">
                                                <label class="pt-2" id="assignRoleDropdownLable">
                                                    {isEditAssignRole[dataindex] ?
                                                        <div className="editDropdownRelativeDiv">
                                                            <div id="assignroledropdown">
                                                                <div class="pr-2" id="createselect">
                                                                    {userRoleList[dataindex].profileRoles.map(sr => sr.roleName).join(", ")}
                                                                </div>
                                                                <div onClick={() => {
                                                                    console.log('yipee')
                                                                    assignroleEditDropdown[dataindex] = !assignroleEditDropdown[dataindex];
                                                                    setAssignroleEditDropdown(assignroleEditDropdown)
                                                                }} class="dropIconContainer">
                                                                    <img src={require('../../../assets/images/drpdwnArrow.svg')}
                                                                        width="11" height="6" class="d-inline-block mt-2" alt="" loading="lazy" />
                                                                </div>
                                                            </div>
                                                            {/* // dropdown */}
                                                            {assignroleEditDropdown[dataindex] && (
                                                                <div class="border" id="editdropdown"
                                                                    ref={container} >
                                                                    {roles.map((role, index) =>
                                                                        (role.type !== 'Requester' && role.type !== 'Respondent' && role.type !== 'Driver' && role.type !== 'Preview') &&
                                                                        <dl id="assignroledl">
                                                                            <dt>
                                                                                <small class="p-1" class="assignroledtcolor">
                                                                                    <img src={(name.profileRoles.filter(pr => pr.roleId == role.roleId).length > 0) ? require('../../../assets/images/checkedBox.svg') : require('../../../assets/images/uncheckedBox.svg')} width="32" height="32" class="d-inline-block pl-2 pr-2"
                                                                                        onClick={
                                                                                            () => {
                                                                                                updateAssignRole(dataindex, index);
                                                                                            }
                                                                                        }
                                                                                    />{role.name}
                                                                                </small>
                                                                            </dt>
                                                                        </dl>
                                                                    )
                                                                    }
                                                                </div>
                                                            )}
                                                        </div>
                                                        :
                                                        <>
                                                            <div data-tip={name.profileRoles.map((role, i) =>
                                                                role.roleName

                                                            ).join(", ")}>
                                                                <div class="pr-2" id="arrowcreateselect">
                                                                    {name.profileRoles.map((role, i) =>
                                                                        role.roleName
                                                                    ).join(", ")}
                                                                </div>
                                                            </div>
                                                            <ReactTooltip place="bottom" effect='solid' arrowColor="#6F6F6F" backgroundColor="#6F6F6F" multiline={true} className="serviceDescriptionReactTooltip" />
                                                        </>
                                                    }
                                                </label>
                                            </td>
                                            <td id="assignroleEdittd" className="assignRoleTableData" style={{ display: !viewOnly ? "none" : null }}>
                                                <div className="rightPartion">
                                                    <img src={isEditAssignRole[dataindex] ? require('../../../assets/images/cross.svg') : ((name.profileRoles.length > 0 && (name.profileRoles[0].roleType == "SuperAdmin" || name.profileRoles[0].roleName == "Super Admin")) || isEditAssignRole.includes(true)) ? require('../../../assets/images/editenable.svg') : require('../../../assets/images/edit.svg')}
                                                        onClick={(name.profileRoles.length > 0 && (name.profileRoles[0].roleType == "SuperAdmin" || name.profileRoles[0].roleName == "Super Admin")) ? null : () => {
                                                            if (!isEditAssignRole.includes(true) || isEditAssignRole[dataindex]) {
                                                                isEditAssignRole[dataindex] = !isEditAssignRole[dataindex]
                                                                setIsEditAssignRole(isEditAssignRole);
                                                                setEditIndex(dataindex);
                                                            }
                                                        }}
                                                        width="16" height="16"
                                                        class="d-inline-block ml-4 mt-2" alt=""
                                                        loading="lazy" />
                                                </div>
                                            </td>
                                            <td id="assignRoleDeleteIconTd" className="assignRoleTableData"
                                                style={{ display: !viewOnly ? "none" : null }}
                                            >
                                                <img src={(name.profileRoles.length > 0 && (name.profileRoles[0].roleType == "SuperAdmin" || name.profileRoles[0].roleName == "Super Admin")) ? require('../../../assets/images/delete_disable.svg') : require('../../../assets/images/delete_enable.svg')}
                                                    onClick={(name.profileRoles.length > 0 && (name.profileRoles[0].roleType == "SuperAdmin" || name.profileRoles[0].roleName == "Super Admin")) ? null : () => deleteAssignRole(dataindex)}
                                                    width="16" height="16" class="d-inline-block" alt="" loading="lazy" />
                                            </td>
                                        </tr>
                                    ))}
                                    {/* Assign Role */}
                                    {openAssignRole && <tr className="assignRoleData" id="assignRole"
                                    >
                                        <td id="assignroletd" className="assignRoleTableData">
                                            <label class="p-2" id="assignrolelable" >
                                                <div class="assignroledisplayflex">
                                                    <div className="pass-wrapper" class="assignroleinputdiv">
                                                        <Input
                                                            type="text"
                                                            id="nameInput"
                                                            class="form-control form-control-sm outline4"
                                                            placeholder="Search by Name"
                                                            name="confirm_password"
                                                            value={input}
                                                            onChange={handlechange}
                                                            autoComplete="off"
                                                        />
                                                        <img id="searchinput_img" src={require('../../../assets/images/search.svg')} width="16" height="16"
                                                            onClick={searchEmail}
                                                        />
                                                    </div>
                                                </div>
                                            </label>
                                        </td>
                                        <td id="userEmailAddressTd" className="assignRoleTableData">
                                            <label class="pt-2" id="userEmailText">
                                                <div className="pass-wrapper" class="assignroleinputdiv">
                                                    <Input
                                                        type="text"
                                                        id="emailInput"
                                                        class="form-control form-control-sm outline4"
                                                        placeholder=""
                                                        autoComplete="off"
                                                        value={userEmail}
                                                        onChange={handleEmailInput}
                                                        readOnly
                                                    />
                                                </div>
                                            </label>
                                        </td>
                                        <td id="roleAssignTd" className="assignRoleTableData">
                                            <label class="pt-2" id="assignRoleDropdownLable">
                                                <div id="assignroledropdown">
                                                    {roleSelected ?
                                                        <div class="pr-2" id="createselect">{getSelectedRoles().map((name) =>
                                                            name.name
                                                        ).join(', ')}</div>
                                                        :
                                                        <div class="pr-2" id="createselect">{selectPlaceHolder}</div>
                                                    }
                                                    <img src={require('../../../assets/images/drpdwnArrow.svg')} onClick={toggleDropdown} width="11" height="6" class="d-inline-block mt-2" alt="" loading="lazy" />
                                                </div>
                                            </label>
                                        </td>
                                        <td id="assignroleEdittd" className="assignRoleTableData">
                                            <div className="rightPartion">
                                                <img src={(isEditMode) ? require('../../../assets/images/editenable.svg') : require('../../../assets/images/edit.svg')}
                                                    width="16" height="16"
                                                    class="d-inline-block ml-4 mt-2" alt=""
                                                    loading="lazy" />
                                            </div>
                                        </td>
                                        <td id="assignRoleDeleteIconTd" className="assignRoleTableData">
                                            <img src={require('../../../assets/images/delete_enable.svg')} width="16" height="16" class="d-inline-block" alt="" loading="lazy" onClick={() => {
                                                setOpenAssignRole(false);
                                                setInput('');
                                                setUserEmail('');
                                                setRoleSelected(false);
                                            }} />
                                        </td>
                                    </tr>}
                                </tbody>
                            </table>
                            {/* FullName Search */}
                            {showSearch &&
                                <div id="namesearchlist" ref={container}>
                                    {(userSearch.map((fullname, userNameIndex) => {
                                        return (
                                            fullname.userType == "TPT Internal" &&
                                            <dl class="pl-3 assignrolenamelist" id="namelisthover" key={userNameIndex} onClick={selectName}>
                                                <dt>
                                                    <small id="assignrolenamelistcolor"  >
                                                        {fullname.firstName + " " + fullname.lastName}
                                                    </small>
                                                </dt>
                                            </dl>
                                        );
                                    }))
                                    }
                                </div>
                            }
                            {/* Email Searcch */}
                            {showEmailSearch &&
                                <div id="emailsearchlist" ref={container}>
                                    {(userSearch.map((email, emailindex) => {
                                        return (
                                            email.userType == "TPT Internal" &&
                                            <dl class="pl-3 assignrolenamelist" id="namelisthover" key={emailindex}
                                                onClick={selectEmail}
                                            >
                                                <dt>
                                                    <small id="assignrolenamelistcolor"  >
                                                        {email.userEmail}
                                                    </small>
                                                </dt>
                                            </dl>
                                        );
                                    }))
                                    }
                                </div>
                            }
                            {/* DropDown */}
                            {dropdown && (
                                <div class="border" id="createdropdown" ref={container} >
                                    {roles.map((name, roleindex) =>
                                        (name.type !== 'Requester' && name.type !== 'Respondent' && name.type !== 'Driver' && name.type !== 'Preview') &&
                                        <dl id="assignroledl">
                                            <dt>
                                                <small class="p-1" class="assignroledtcolor">
                                                    <img src={(roleSelectStatus[roleindex]) ? require('../../../assets/images/checkedBox.svg') : require('../../../assets/images/uncheckedBox.svg')} width="32" height="32" class="d-inline-block pl-2 pr-2"
                                                        onClick={() => {
                                                            roleSelectStatus[roleindex] = !roleSelectStatus[roleindex];
                                                            setRoleSelectStatus(roleSelectStatus);
                                                            setRoleSelected(true)
                                                        }} />{name.name}
                                                </small>
                                            </dt>
                                        </dl>
                                    )
                                    }
                                </div>
                            )}
                            <nav class="navbar navbar-light bg-white" id="assignrolenav" style={{ display: !viewOnly ? "none" : null }}>
                                <a
                                    href="#assignRole"
                                    onClick={() => {
                                        setOpenAssignRole(true);
                                    }}
                                    style={{
                                        pointerEvents: openAssignRole ? "none" : null
                                    }}
                                    class="text-left">
                                    <img src={openAssignRole ? require('../../../assets/images/plus_disable.svg') : require('../../../assets/images/add.svg')} id="addrole" width="19" height="19" class="d-inline-block" alt="" loading="lazy" />
                                    <small class="pt-2 pb-2" id="addNewRoleLink" style={{ color: openAssignRole ? "#B6B6B6" : "#428BCA" }}>Assign Role</small>
                                </a>
                                <div class="text-right p-3" id="assignrolefloat" >
                                    <Button type="button" class="btn btn-sm p-1 pr-3 pl-3"
                                        disabled={!validateFormFields()}
                                        id="confirmAssignRole"
                                        onClick={handleSubmit}
                                    >
                                        Confirm</Button>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <DeleteModal hasOpen={hasOpenDelete} onClick={onCloseDeleteModal} onYesClick={unassignRoleFromUser} >
                <p className="deletemodalText">Do you really want to unassign role from this user?</p>
            </DeleteModal>
            <RespModal hasOpen={hasopen}>
                <div id="addrolerespdiv">
                    <Image src={require('../../../assets/images/success.svg')} /><br /><br />
                    <p id="addrolerespp">Confirmed</p><br />
                    <Button
                        type="button"
                        class="addrolerespbutton"
                        onClick={onCloseConfirmedModal}
                    >OK
                  </Button>
                </div>
            </RespModal>
        </div>
    );
}
export default AssignRole;